// import Swiper from 'swiper';
// import { Pagination, Navigation, EffectFade, Autoplay } from 'swiper/modules';
// import { $Qll } from '../utils/query-selector';

// // import styles bundle
// import 'swiper/css/bundle';
// import "../scss/components/_hero.scss";

import Swiper from 'swiper';
import { Pagination, Navigation, fadeEffect, EffectFade } from 'swiper/modules';

const sliderHeroComponent = () => {
  const swiperHero = document.querySelectorAll('.jc-hero-swiper');

  for (let i = 0; i < swiperHero.length; i++) {
    let swiperPagination = swiperHero[i].querySelector('.hero__pagination');
    let swiperNext = swiperHero[i].querySelector('.hero__arrow--next');
    let swiperPrev = swiperHero[i].querySelector('.hero__arrow--prev');

    new Swiper('#' + swiperHero[i].id, {
      modules: [Pagination, Navigation, EffectFade],
      spaceBetween: 8,
      slidesPerView: 'auto',
      loop: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      effect: 'fade', // Enable fade effect
      watchSlidesProgress: true,
      fadeEffect: {
        crossFade: true, // Smooth fade transition
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
      },
      navigation: {
        nextEl: swiperNext,
        prevEl: swiperPrev,
      },
    });
  }
};

export default sliderHeroComponent;

// const sliderHeroComponent = () => {
//   let swipersbundleset = [];
//   let swiperWrapper = document.querySelector('.jc-hero-swiper');

//   function initSwipersBundleSet() {
//     const swiperElements = $Qll('.jc-hero-swiper');
//     swiperElements.forEach((element) => {

//       let swiperPagination = element.querySelector('.hero__pagination');

//       console.log('swiperPagination', swiperPagination);
//       const swiper = new Swiper(element, {
//         modules: [Pagination, Navigation, EffectFade, Autoplay],
//         slidesPerView: 1,
//         spaceBetween: 0,
//         loop: true,
//         observer: true,
//         effect: 'fade', // Enable fade effect
//         watchSlidesProgress: true,
//         fadeEffect: {
//           crossFade: true, // Smooth fade transition
//         },
//         autoplay: {
//           delay: 5000,
//          // disableOnInteraction: true,
//         },
//         observeParents: true,
//         pagination: {
//           el: swiperPagination,
//           clickable: true
//         },
//         navigation: {
//           nextEl: '.hero__arrow--next',
//           prevEl: '.hero__arrow--prev',
//         },
//       });

//       swipersbundleset.push(swiper);
//     });

//     swipersbundleset.forEach(function (swiper) {
//       swiper.init();
//     });
//   }

//   function destroySwipersBundleSet() {
//     swipersbundleset.forEach(function (swiper) {
//       swiper.destroy();
//     });

//     swipersbundleset = [];
//   }

//   if ( swiperWrapper && swiperWrapper.classList.contains('desktop-disabled') ) {
//     if (window.innerWidth >= 992) {
//       destroySwipersBundleSet();
//     } else {
//       if (swipersbundleset.length === 0) {
//         initSwipersBundleSet();
//       }
//     }
//   } else {
//     initSwipersBundleSet();
//   }

//   window.addEventListener('resize', function () {
//     if ( swiperWrapper && swiperWrapper.classList.contains('desktop-disabled') ) {
//       if (window.innerWidth >= 992) {
//         destroySwipersBundleSet();
//       } else {
//         if (swipersbundleset.length === 0) {
//           initSwipersBundleSet();
//         }
//       }
//     } else {
//       initSwipersBundleSet();
//     }
//   });

// };

// export default sliderHeroComponent;
